import { render, staticRenderFns } from "./PositionsTypeSelect.vue?vue&type=template&id=8c7fe47e&"
import script from "./PositionsTypeSelect.vue?vue&type=script&lang=js&"
export * from "./PositionsTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports